(function () {
  var D = window.TOD_SOLO; if (!D || !D.cape) return;
  var $ = function(id){ return document.getElementById(id); };
  /* 30 SEP 2026. Mack: "a box to see the live thread colors" and "mark white
     and gold as popular and put them 2 first". The same photographs and the
     same order as the set designer (tod-bundle.js): each cone stitched on
     black on the BAi, one strip image beside this file, keyed by spool. */
  var TP_POP=['401','1050'];
  var TP_IDX={'401':0,'1050':1,'4':2,'164':3,'270':4,'323':5,'1184':6,'48':7,
              '1086':8,'1002':9,'334':10,'1129':11,'519':12}, TP_N=13;
  var TP_URL=(function(){
    var s=(document.currentScript&&document.currentScript.src)||'';
    return s?s.replace(/[^\/?#]+(\?[^#]*)?(#.*)?$/,'tod-thread-samples.jpg'):'';
  })();
  function tpEsc(x){return String(x).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;')}
  function isPopular(t){return TP_POP.indexOf(String(t&&t.spool))>=0}
  var TP_MORE='<details class="tp-more"><summary>Can’t find your color?</summary><div>We might have a spool that works for you — we have 60+ colors on hand. Send us a text: <a href="sms:+14693685805">(469) 368-5805</a></div></details>';
  function popFirst(list){
    var pop=[],rest=[];
    list.forEach(function(t){ (isPopular(t)?pop:rest).push(t) });
    pop.sort(function(a,b){return TP_POP.indexOf(String(a.spool))-TP_POP.indexOf(String(b.spool))});
    return pop.concat(rest);
  }
  /* the photo box stays and only its strip and words change, so it does not blink between colours */
  function tpSwap(box,t){
    var img=box.querySelector('.tphoto:not(.none) .tp-img'), k=TP_IDX[String(t.spool)], bb=box.querySelector('.tphoto b');
    if(!img||!bb||k==null||!TP_URL) return false;
    img.style.backgroundPosition='0 '+(k/(TP_N-1)*100).toFixed(4)+'%';
    img.setAttribute('aria-label',t.name+' thread stitched on black');
    bb.innerHTML=(isPopular(t)?'<em class="tp-pop">Popular</em>':'')+'Real thread \u2013 '+tpEsc(t.name)+' '+tpEsc(t.spool);
    return true;
  }
  function threadPhoto(t){
    var k=TP_IDX[String(t.spool)], pop=isPopular(t)?'<em class="tp-pop">Popular</em>':'';
    var head='<b>'+pop+tpEsc(t.name)+' · '+tpEsc(t.spool)+'</b>';
    if(k==null||!TP_URL)
      return '<div class="tphoto none"><i class="tp-img" style="background:'+t.hex+'"></i><span>'+head+'Stitched sample coming soon</span></div>'+TP_MORE;
    return '<div class="tphoto"><i class="tp-img" role="img" aria-label="'+tpEsc(t.name)+' thread stitched on black" style="background-image:url('+
           TP_URL+');background-position:0 '+(k/(TP_N-1)*100).toFixed(4)+'%"></i><span><b>'+pop+'Real thread \u2013 '+tpEsc(t.name)+' '+tpEsc(t.spool)+'</b></span></div>'+TP_MORE;
  }
  (function(){ if(document.getElementById('tp-css')) return;
    var st=document.createElement('style'); st.id='tp-css';
    st.textContent='.tphoto{display:flex;align-items:center;gap:12px;margin:12px 0 2px;padding:8px 10px 8px 8px;border:1px solid rgba(15,24,40,.12);border-radius:10px;background:#fff}.tphoto .tp-img{flex:0 0 auto;display:block;width:150px;aspect-ratio:400/190;border-radius:6px;background-color:#1c1c1e;background-size:100% auto;background-repeat:no-repeat}.tphoto.none .tp-img{width:40px;height:40px;aspect-ratio:auto;border-radius:50%;margin:0 55px}.tphoto span{font-size:12.5px;line-height:1.35;color:#6b6158;min-width:0}.tphoto b{display:block;font-size:13.5px;font-weight:600;color:#1E2D4A;margin-bottom:2px}.tp-pop{font-style:normal;font-size:9.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;background:#B8923A;color:#fff;border-radius:10px;padding:2px 7px!important;margin:0 8px 0 0!important;display:inline-block!important;vertical-align:1px}.sp.pop::before,#cb-threads label.pop::before{content:\'\\2605\';position:absolute;right:-4px;bottom:-4px;width:15px;height:15px;border-radius:50%;background:#B8923A;color:#fff;font-size:9px;line-height:15px;text-align:center;box-shadow:0 0 0 2px #fff;z-index:1}.tp-more{margin:8px 0 0;font-size:13px;color:#1E2D4A}.tp-more summary{cursor:pointer;display:inline-block;color:#1E2D4A!important;background:none!important;padding:0!important;font-weight:600;text-decoration:underline;text-underline-offset:3px;list-style:none}.tp-more summary::-webkit-details-marker{display:none}.tp-more summary::before{content:\'+ \'}.tp-more[open] summary::before{content:\'\\2212 \'}.tp-more div{margin-top:6px;padding:10px 12px;background:#FAF6EC;border:1px solid rgba(15,24,40,.12);border-radius:8px;line-height:1.45;color:#3d3833}.tp-more a{color:#7A4F60!important;text-decoration:underline;font-weight:700;white-space:nowrap}@media(max-width:480px){.tphoto .tp-img{width:120px}.tphoto.none .tp-img{margin:0 40px}}';
    document.head.appendChild(st); })();
  var NS='http://www.w3.org/2000/svg';
  function el(t,a){ var e=document.createElementNS(NS,t); for(var k in a){ e.setAttribute(k,a[k]); } return e; }

  /* 28 Sep 2026: this line used to rewrite tod-core's banner to "free over $75", and
     snippets/tod-ship.liquid then corrected it back to $60. tod-core's own banner has said
     $60 since 20 Sep and now carries a short phone version too, so the rewrite is gone and
     this page shows the same banner as every other page. */

  /* ---- THE SHOP'S OWN ALPHABETS, SPOOLS AND HEIGHTS ------------------------
     Copied from assets/tod-bundle.js (the set designer) so this page stitches
     from the same catalogue: the same seventeen .dst alphabets the Order Desk
     runs, the same fifteen Madeira spools, the same 25 / 32 / 38 mm heights.
     webK is that file's estimate of the stand-in typeface's font-size per
     millimetre of capital height. */
  var BUILTIN=[
    {id:"great-vibes",name:"Great Vibes",lab:"Fine signature",web:"'Great Vibes',cursive",k:1.35},
    {id:"old-english",name:"Old English",lab:"Classic barber",web:"'UnifrakturMaguntia',cursive",k:1.04},
    {id:"barber",name:"Barber",lab:"Classic barber",web:"'Rye',serif",k:0.92},
    {id:"anderson",name:"Anderson",lab:"Flowing script",web:"'Allura',cursive",k:1.55},
    {id:"murphy",name:"Murphy",lab:"Flowing script",web:"'Sacramento',cursive",k:1.45},
    {id:"alexander",name:"Alexander",lab:"Flowing script",web:"'Berkshire Swash',cursive",k:1.1},
    {id:"emerson",name:"Emerson",lab:"Flowing script",web:"'Yellowtail',cursive",k:1.26},
    {id:"william",name:"William",lab:"Flowing script",web:"'Kaushan Script',cursive",k:1.24},
    {id:"samantha",name:"Samantha",lab:"Flowing script",web:"'Alex Brush',cursive",k:1.48},
    {id:"twilight-mint",name:"Twilight Mint",lab:"Flowing script",web:"'Dancing Script',cursive",k:1.2},
    {id:"twilight-crumbs",name:"Twilight Crumbs",lab:"Flowing script",web:"'Parisienne',cursive",k:1.5},
    {id:"golden-butter",name:"Golden Butter",lab:"Flowing script",web:"'Pacifico',cursive",k:1.02},
    {id:"snuggle-bear",name:"Snuggle Bear",lab:"Soft rounded",web:"'Quicksand',sans-serif",k:0.96},
    {id:"bubble-grove",name:"Bubble Grove",lab:"Soft rounded",web:"'Baloo 2',cursive",k:0.95},
    {id:"puddle-jump",name:"Puddle Jump",lab:"Soft rounded",web:"'Comfortaa',cursive",k:1.05},
    {id:"happy-tangle",name:"Happy Tangle",lab:"Playful",web:"'Shadows Into Light',cursive",k:1.35},
    {id:"noddle-sketch",name:"Noddle Sketch",lab:"Playful",web:"'Gloria Hallelujah',cursive",k:1.35}
  ];
  /* 26 OCT 2026. An alphabet can be taken off the shop without a new theme:
     window.TOD_HIDE_FONTS, written beside the glyph links. Bubble Grove is the
     first - the machine sets it wider than its own field. */
  function shown(f){ return !(window.TOD_HIDE_FONTS||{})[f.id]; }
  BUILTIN = BUILTIN.filter(shown);
  var FONTS=BUILTIN.slice();
  /* The cones actually on the BAi, checked spool by spool on 16 Aug 2026 -
     the same list the live set designer shows (snippets/tod-threads.liquid). */
  /* 12 SEP 2026. These were the 16 Aug names, and four of them have since
     been renamed on the machine: Coral Pink is Petal Pink, Teal Green is
     Aqua, Magenta is Hot Pink, Royal Blue is Azure. The spool numbers never
     moved, which is why nothing was ever mis-stitched - but for the moment
     before fonts.json lands the page was offering cones under names the
     workshop stopped using, in hexes that were never quite right. This list
     is now make_order.py's own, in its own order, so the first paint and the
     paint after the manifest arrives show the same fifteen. */
  var BUILTIN_THREADS=[
    {name:'White',spool:'401',hex:'#E5E7EB'},       {name:'Cream',spool:'674',hex:'#EBDBC4'},
    {name:'Petal Pink',spool:'4',hex:'#F7C8DB'},    {name:'Champagne',spool:'164',hex:'#E0CEC2'},
    {name:'Lavender',spool:'270',hex:'#DAC1E9'},    {name:'Aqua',spool:'323',hex:'#93D4E0'},
    {name:'Silver',spool:'1184',hex:'#C6C7CD'},     {name:'Blush Pink',spool:'48',hex:'#FAADB6'},
    {name:'Gold',spool:'1050',hex:'#DAB654'},       {name:'Sky Blue',spool:'1086',hex:'#47B8DF'},
    {name:'Hot Pink',spool:'1002',hex:'#F189B9'},   {name:'Azure',spool:'334',hex:'#42A7F0'},
    {name:'Bronze',spool:'739',hex:'#BB9181'},      {name:'Medium Purple',spool:'1129',hex:'#A272D9'},
    {name:'Red',spool:'519',hex:'#EF3139'}
  ];
  var THREADS=BUILTIN_THREADS.slice();
  var HEIGHTS=[{key:'standard',label:'Standard',mm:25},{key:'taller',label:'Medium',mm:32},{key:'tallest',label:'Tallest',mm:38},{key:'grand',label:'Grand',mm:51}];
  /* 11 SEP 2026. GRAND, the fourth step. The hoop field is 260 x 200 mm and
     the tallest thing the page would sell was one 38 mm line - so of 200 mm of
     height, 38 were being used. What the size buttons mostly did was buy WIDTH,
     because on any name long enough to matter the width cap had already decided
     the letter height and the extra millimetres went nowhere.

     51 mm rather than 44: every alphabet in the manifest carries 51 (eight of
     them call it 50, a millimetre nobody can see), while 44 exists in only six
     of the thirty. A size the page offers has to be a size every alphabet can
     actually be stitched at.

     It will not fit a long name, and that is the point of the message beside
     it - the page now says WHICH line is too long and by how much, instead of
     quietly shrinking the letters and leaving the customer wondering why the
     button did nothing. A short name gets the height it asks for. */
  var LINE_GAP_MM=4;

  /* ---- ONE CATALOGUE, SHARED WITH THE SET DESIGNER -------------------------
     6 Sep 2026. The tables above were COPIED out of assets/tod-bundle.js when
     this page was built, and a copy drifts. By today the set designer offered
     thirty alphabets in eight groups and this page offered seventeen in a flat
     row with four of them filed under the wrong heading; and the fifteen cones
     here were still the pre-16-August names, so the page sold Teal Green - in
     green - when there has never been a green cone on the machine and the
     order would have come out Aqua.

     So this page now reads fonts.json at load, the same manifest the set
     designer reads, and rebuilds its alphabets, cones and heights from it. The
     tables above stay as the fallback for a manifest that never arrives, and
     as the source of the stand-in typefaces - which stand-in an alphabet
     borrows is a theme decision, not something the font data should carry,
     which is the rule tod-bundle.js already follows. */
  function byKey(list,k,v){ for(var i=0;i<list.length;i++) if(list[i][k]===v) return list[i]; return null; }
  function applyManifest(m){
    var stand={}; BUILTIN.forEach(function(f){ stand[f.id]=f; });
    FONTS = m.fonts.filter(shown).map(function(f){
      var b=stand[f.id]||{};
      return { id:f.id, name:f.name, lab:f.styleLabel||b.lab||'',
               web:(b.web||f.web||'cursive'),
               k:(b.k!=null?b.k:(f.webK||1.2)),
               gf:(b.gf!==undefined?b.gf:f.gf),
               allCaps:!!f.allCaps };
    });
    /* Stand-in typefaces for any alphabet this theme did not already link. */
    var want=[]; FONTS.forEach(function(f){ if(f.gf && !stand[f.id]) want.push(f.gf); });
    if (want.length){
      var lk=document.createElement('link'); lk.rel='stylesheet';
      lk.href='https://fonts.googleapis.com/css2?'+want.map(function(g){return 'family='+g;}).join('&')+'&display=swap';
      document.head.appendChild(lk);
    }
    if (m.threads && m.threads.length) THREADS=m.threads.slice();
    if (m.heights && m.heightNames && m.heights.cape){
      HEIGHTS=m.heightNames.map(function(k){
        return {key:k, label:(m.heightLabels&&m.heightLabels[k])||k, mm:m.heights.cape[k]};
      });
      /* The manifest is the workshop's list and it stops at 38 mm. Grand is a
         page decision until fonts.json carries it, so it is put back on the end
         rather than being lost the moment the manifest lands. */
      if (!byKey(HEIGHTS,'key','grand')) HEIGHTS.push({key:'grand',label:'Grand',mm:51});
    }
    /* Keep what the customer has already chosen, matched on the thing that
       identifies it rather than on its position in a list that just changed. */
    /* 19 SEP 2026. Three lines, and each one carries its own alphabet, cone
       and size - so the re-match after a manifest lands is done per line
       rather than once for the page. Same rule as before: match on the thing
       that identifies a font or a cone, never on its position in a list that
       has just changed underneath it. */
    for (var li=0; li<3; li++){
      S.fonts[li]   = byKey(FONTS,'id',S.fonts[li]&&S.fonts[li].id) || FONTS[0];
      S.threads[li] = byKey(THREADS,'spool',S.threads[li]&&S.threads[li].spool) || byKey(THREADS,'name','Gold') || THREADS[0];
      S.heights[li] = byKey(HEIGHTS,'mm',S.heights[li]&&S.heights[li].mm) || HEIGHTS[0];
      S.aHeights[li]= byKey(HEIGHTS,'mm',S.aHeights[li]&&S.aHeights[li].mm) || S.heights[li];
    }
    renderFonts(); renderThreads(); renderHeights(); paint();
  }
  function loadManifest(){
    var u=window.TOD_FONTS_URL; if(!u) return;
    fetch(u).then(function(r){ return r.ok?r.json():null; })
      .then(function(m){ if(m&&m.fonts&&m.fonts.length) applyManifest(m); })
      .catch(function(){});
  }

  /* ---- THE REAL ALPHABETS --------------------------------------------------
     Each file is the alphabet as the machine stitches it: one entry per
     character, [path, width, height above the baseline, depth below it], in
     tenths of a millimetre at the size named by srcMm. kk is a kerning table,
     two characters per pair, indexed by position in ord.

     Fetched on demand and cached. Until a file lands the stand-in web font is
     drawn, exactly as before, so a slow connection sees the old behaviour
     rather than an empty cape - and if a fetch fails that is where it stays. */
  var GLYPHS={}, GPEND={};
  var GFAIL = {};
  function glyphs(id){ return GLYPHS[id] || null; }
  /* 26 OCT 2026. ONE FILE PER SIZE. The machine builds a 51 mm line from the
     pack's own 51 mm letters, which are drawn and spaced differently from the
     25 mm ones this page used to enlarge - so a name measured 167 mm here and
     stitched 159, and Book Serif was sold as fitting a 210 mm cape and came
     out 217. A key is now either an alphabet ("anderson", its base file) or
     an alphabet at a size ("anderson@51"), and glyphsAt() hands back the file
     the Order Desk would build that height from: make_order.pick_source,
     the size asked for if the pack has it, otherwise the next one up. */
  function glyphUrl(key){
    var at=key.indexOf('@');
    if (at<0) return (window.TOD_GLYPHS||{})[key] || null;
    var m=(window.TOD_GLYPH_SIZES||{})[key.slice(0,at)];
    return (m && m[key.slice(at+1)]) || null;
  }
  function srcFor(id, mm){
    var m=(window.TOD_GLYPH_SIZES||{})[id]; if(!m) return null;
    var ks=Object.keys(m).map(Number).filter(function(v){ return v>0; }).sort(function(a,b){ return a-b; });
    if(!ks.length) return null;
    for (var i=0;i<ks.length;i++) if (ks[i]>=mm) return ks[i];
    return ks[ks.length-1];
  }
  function glyphsAt(id, mm){
    var src=srcFor(id, mm), base=GLYPHS[id]||null;
    if (src===null) return base;
    if (base && base.srcMm===src) return base;
    var key=id+'@'+src;
    if (GLYPHS[key]) return GLYPHS[key];
    /* a size file that will not come is not allowed to hold the page up:
       the base file enlarged is what this page drew before today */
    if (GFAIL[key] || !glyphUrl(key)) return base;
    loadGlyphs(key, function(){ try{ paint(); }catch(e){} });
    return null;
  }
  /* Width in mm of one line at one height, from the file that height is
     built from; null while that file is still on its way. */
  function widthAt(id, text, mm){
    var d=glyphsAt(id, mm); if(!d) return null;
    if(!canSet(d,text)) return NaN;
    return glyphWidth(d,text)*((mm/(d.srcMm||25))/10);
  }
  /* The height a line actually comes out at in a field of `cap` mm. The old
     arithmetic shrank in proportion, which only holds while every height is
     the same file enlarged; with a file per size the width does not scale in
     a straight line, so the answer is checked at the height it lands on and
     stepped down until it fits - the same test the Order Desk applies. */
  function fitAt(id, text, mm, cap){
    var w=widthAt(id,text,mm); if(w===null || isNaN(w)) return w;
    if (w<=cap) return mm;
    var m=Math.max(12, Math.floor(mm*cap/w)), guard=0;
    while (m>12 && guard++<40){
      var wm=widthAt(id,text,m); if(wm===null) return null; if(isNaN(wm)) return NaN;
      if (wm<=cap) break;
      m--;
    }
    return m;
  }
  /* Every caller gets its callback back.
     The first version kept ONE and dropped any that arrived while the fetch
     was still out, and that lost the preview on a phone. On a narrow screen
     the alphabet row is on screen at once, so a chip asked for Happy Tangle
     first and the preview asked a moment later - the preview's repaint was
     the one thrown away, the chip changed, and the cape kept the stand-in
     until the next keystroke. On a desktop the row is usually scrolled past
     the fold and the order came out the other way round, which is why it
     looked right there and wrong on a phone. */
  function loadGlyphs(id, cb){
    if (GLYPHS[id]) { if(cb) cb(GLYPHS[id]); return; }
    /* An alphabet that has already failed is not asked for again. Without
       this, drawArt re-asks on every repaint and loadGlyphs repaints on every
       failure: paint -> drawArt -> loadGlyphs -> paint, thousands deep, until
       the stack gives out - and the catch swallows the error, so the only
       symptom is a phone that locks up for a minute on a font whose file is
       missing from tod-glyph-urls. A failed fetch had the same loop at
       network speed. */
    if (GFAIL[id]) return;
    var url = glyphUrl(id);
    if (!url) { GFAIL[id]=1; try{ paint(); }catch(e){} return; }
    if (GPEND[id]) { if(cb) GPEND[id].push(cb); return; }
    GPEND[id] = cb ? [cb] : [];
    fetch(url).then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var q=GPEND[id]||[]; GPEND[id]=null;
        if (!j || !j.g || !j.ord) { GFAIL[id]=1; try{ paint(); }catch(e){} return; }
        GLYPHS[id]=j;
        for (var i=0;i<q.length;i++){ try{ q[i](j); }catch(e){} }
        /* and the cape itself, whoever asked - belt and braces, because this
           is the one thing on the page the customer is buying from. */
        try{ paint(); }catch(e){}
      })
      .catch(function(){ GPEND[id]=null; GFAIL[id]=1; try{ paint(); }catch(e){} });
  }
  function kernOf(d,a,b){
    var o=d.ord, n=o.length, i=o.indexOf(a), j=o.indexOf(b);
    if (i<0||j<0||!d.kk) return 0;
    var off=(i*n+j)*2, c0=d.kk.charCodeAt(off), c1=d.kk.charCodeAt(off+1);
    if (isNaN(c0)||isNaN(c1)) return 0;
    var v=d.kv[(c0-32)*90+(c1-32)];
    return typeof v==='number' ? v : 0;
  }
  /* THE PEN WALK, character for character the way the Order Desk walks it.
     6 Sep: it used to skip anything it had no drawing for - and no alphabet
     file carries a drawing for a SPACE, so every space was worth nothing.
     "Shine hair studio" measured 8% narrow, the page offered 27 mm where only
     24 fits the cape, and the preview drew the words run together. The space
     is a real advance: it is the spaceT the file has carried all along. It
     also breaks the kerning run rather than being kerned across, and trackT
     opens whatever pairs are left, both exactly as the desk does it.
     The width returned is the ink box, so a leading or trailing space is not
     counted - the desk does not count one either. */
  function glyphBox(d,text){
    var pen=0, prev=null, n=0, x0=0, x1=0;
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      /* 26 Oct: a space starts after the ink, as layout() now does */
      if (ch===' '){ if(n && x1>pen) pen=x1; pen+=(d.spaceT||0); prev=null; continue; }
      var e=d.g[ch];
      if (!e){ prev=null; continue; }
      if (prev!==null) pen+=kernOf(d,prev,ch)+(d.trackT||0);
      if (!n || pen<x0) x0=pen;
      if (!n || pen+e[1]>x1) x1=pen+e[1];
      pen+=e[1]; prev=ch; n++;
    }
    return n ? {x0:x0, w:x1-x0} : null;
  }
  /* Width of a line in glyph units, kerning included. */
  function glyphWidth(d,text){ var b=glyphBox(d,text); return b?b.w:0; }
  /* Draw one line on a baseline, centred on cx. mm is the capital height the
     customer chose; the file is cut at d.srcMm, so one glyph unit is
     (mm/srcMm)/10 of a stage millimetre. */
  function drawGlyphLine(parent,d,text,cx,baseY,mm,fill){
    var b=glyphBox(d,text); if(!b) return 0;
    var s=(mm/(d.srcMm||25))/10, x=cx-(b.w*s)/2-b.x0*s, pen=0, prev=null, drew=0, rt=null;
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      if (ch===' '){ if(rt!==null && rt>pen) pen=rt; pen+=(d.spaceT||0); prev=null; continue; }
      var e=d.g[ch];
      if (!e){ prev=null; continue; }
      if (prev!==null) pen+=kernOf(d,prev,ch)+(d.trackT||0);
      var gx=x+pen*s, gy=baseY-e[2]*s;
      var grp=el('g',{transform:'translate('+gx.toFixed(2)+','+gy.toFixed(2)+') scale('+s.toFixed(5)+')'});
      grp.appendChild(el('path',{d:e[0],fill:'none',stroke:fill,'stroke-width':4.2,
        'stroke-linecap':'round','stroke-linejoin':'round'}));
      parent.appendChild(grp);
      pen+=e[1]; prev=ch; drew++;
      if (rt===null || pen>rt) rt=pen;
    }
    return drew;
  }
  /* Every character in the line has a drawing, so the alphabet can set it.
     A SPACE has no drawing and never will, and this used to fail on it - so
     any name with a space fell through to the stand-in web font, which since
     the 6 Sep change leaves Add to cart stuck on "One moment...". A space is
     settable: the machine simply moves the pen. */
  function canSet(d,text){
    for (var i=0;i<text.length;i++){
      var ch=text[i];
      if (ch!==' ' && !d.g[ch]) return false;
    }
    return true;
  }

  /* ---- THE STAGE, AT ONE PIXEL PER MILLIMETRE ------------------------------
     The set designer draws the cape at 0.558 svg units per mm with the chest
     line at y 126 of a 608.8-tall frame; the same photo here is scaled so a
     millimetre is one stage pixel, and the lettering is centred on the chest
     the way the Order Desk hoops it - centred, never off to one side.
       cape  : 1920x2403 photo, 2.29 px/mm -> drawn 832 wide (x -156), chest y 205
       apron : 400x912 cut-out, 0.967 px/mm -> drawn 414 wide (x 53),   chest y 205 */
  var GEO={
    cape:  {img:D.capeImg,  x:-156, y:-10, w:832, h:1041, chest:205, maxMm:180},
    apron: {img:D.apronImg, x:53,   y:-84, w:414, h:943,  chest:205, maxMm:150}
  };

  /* THE SIZE BUTTON SETS THE FIELD TOO. Mack, 10 Sep 2026: "180mm on
     standard 210 medium 250 tallest". Picking a bigger size used to raise the
     letter height and nothing else, so on a long salon name the width cap had
     already decided the answer and every button gave the same millimetre.
     Now the room grows with the letters, which is what makes the buttons do
     something on exactly the designs that needed them most.

     By POSITION, not by millimetre: loadManifest can rebuild HEIGHTS from the
     shop's own list and a table keyed on 25/32/38 would quietly fall back to
     the Standard field the day those numbers move.

     Capes only. The apron keeps the one 150 mm field it has always had - its
     own sizes are 150/180/230 in the workshop, which is a different question
     and not one being asked today. */
  /* 11 SEP 2026. The apron used to sit on one flat 150 mm field at every
     size, so its buttons moved the letter height and nothing else - the same
     complaint the cape had, still true on the apron after the cape was fixed.
     Now both garments step, each on its own ladder: the apron bib is narrower
     than a cape chest, so it starts and finishes smaller. The three apron
     numbers are make_order.py's own PRODUCT_WIDTH for the apron - 150 / 180 /
     230 - so the page, the bundle generator and the machine all agree. */
  var FIELD_MM = { cape: [180, 210, 250, 250], apron: [150, 180, 230, 230] };
  /* What the workshop calls the three fields. Held as a list rather than a
     table keyed on millimetres, because 180 mm is the cape's Standard and the
     apron's Large - the same number means two different things depending on
     what it is being stitched onto. */
  var SIZE_WORD = ['Standard', 'Large', 'X-Large', 'X-Large'];
  function fieldIdx(h){ return HEIGHTS.indexOf(h); }
  function fieldIn(view, h){
    var arr = FIELD_MM[view], i = fieldIdx(h);
    return (arr && i >= 0 && arr[i] != null) ? arr[i] : GEO[view].maxMm;
  }
  function fieldFor(h){ return fieldIn(S.view, h); }

  /* 19 SEP 2026. THREE LINES, EACH WITH ITS OWN ALPHABET, CONE AND SIZE.
     Mack: "make it were the homepage designer can have 2 different fonts and
     2 different colors ... for line 2 and the option to make a line 3". The
     BAi changes colour on its own, so nothing here is held to one cone.

     Everything that used to be a pair of fields is a three-slot array now,
     indexed by the LINE'S OWN NUMBER - 0 1 2 - and never by its position
     among the lines that happen to be filled in. That distinction is the
     whole of it: a customer who leaves line one empty and types into line
     two used to have line two measured against line ONE'S height, because
     the old lines() filtered the blanks out and everything downstream
     counted from there. With one font on the page that was invisible. With
     three it would put the wrong alphabet on somebody's cape. liveIdx()
     keeps the real numbers and every lookup goes through it.

     S.rows is how many boxes are on screen, not how many are filled - a line
     can be added and left empty while somebody thinks about it, and an empty
     line is simply not stitched. */
  var GOLD = (byKey(THREADS,'name','Gold') || THREADS[0]);
  var S = { mode:'name', handle:'', rows:2, fline:0, tline:0,
            names:  ['','',''],
            /* Gold BY NAME, not by position. It was THREADS[13] when the
               built-in list was in the 16 Aug order; in the workshop's own
               order 13 is Medium Purple, and every cape on the site would
               quietly have defaulted to purple. */
            fonts:  [FONTS[0], FONTS[0], FONTS[0]],
            threads:[GOLD, GOLD, GOLD],
            heights:[HEIGHTS[0], HEIGHTS[0], HEIGHTS[0]], tied:true,
            apron:false, qty:1, apronQty:1, view:'cape',
            aHeights:[HEIGHTS[0], HEIGHTS[0], HEIGHTS[0]], aTied:true, aOwn:false };

  /* LINES TWO AND THREE FOLLOW LINE ONE UNTIL SOMEBODY GIVES THEM THEIR OWN.
     Same shape as the apron's S.aOwn and for the same reason: a customer who
     deliberately sets line two to the alphabet line one is already wearing
     has still made a choice, and a later change to line one must not quietly
     undo it. So it is a flag per line, not a comparison of the three. */
  S.fontSet   = [true,false,false];
  S.threadSet = [true,false,false];
  function fontOf(i){   return S.fontSet[i]   ? S.fonts[i]   : S.fonts[0]; }
  function threadOf(i){ return S.threadSet[i] ? S.threads[i] : S.threads[0]; }
  function setFont(i,f){
    S.fonts[i]=f; S.fontSet[i]=true;
    if (i===0) for (var k=1;k<3;k++) if(!S.fontSet[k]) S.fonts[k]=f;
  }
  function setThread(i,t){
    S.threads[i]=t; S.threadSet[i]=true;
    if (i===0) for (var k=1;k<3;k++) if(!S.threadSet[k]) S.threads[k]=t;
  }
  /* True while every FILLED line wears the same alphabet / cone. This is what
     decides whether the order carries one Font property or one per line, so
     it asks about the lines being stitched and ignores the rest. */
  function oneFont(){
    var ix=liveIdx();
    for (var i=1;i<ix.length;i++) if (fontOf(ix[i])!==fontOf(ix[0])) return false;
    return true;
  }
  function oneThread(){
    var ix=liveIdx();
    for (var i=1;i<ix.length;i++) if (threadOf(ix[i])!==threadOf(ix[0])) return false;
    return true;
  }
  /* Anything that wants telling when the design changes - see TOD_SOLO_API at
     the foot of this file. */
  var HOOKS=[];

  /* 12 SEP 2026. THE APRON GETS TWO SIZES OF ITS OWN.
     Mack: "allow the apron to get different sizes individually on the 2 lines,
     have it follow the cape design as default."

     Until today the apron wore whatever the cape wore. That is the right
     STARTING point - almost nobody wants the two to disagree - but it was also
     the only one on offer, and the bib is not a chest: the apron's fields are
     150 / 180 / 230 against the cape's 180 / 210 / 250, so the very same size
     word lands on a narrower piece of cloth and a name that sits comfortably
     across a cape can be the one that gets clamped on the apron.

     So the apron keeps following until somebody taps a size while looking at
     it. That tap copies the cape's two heights across (claimApron) and from
     then on the apron is its own - which is why S.aOwn exists rather than a
     comparison of the four heights: a customer who deliberately sets the apron
     to the same size the cape is on has still made a choice, and a later
     change to the cape must not quietly undo it. "Match the cape again" puts
     it back. */
  function sizeTrio(view){
    var own = (view === 'apron' && S.aOwn);
    var src = own ? S.aHeights : S.heights, tied = own ? S.aTied : S.tied;
    return [src[0], tied ? src[0] : src[1], tied ? src[0] : src[2]];
  }
  function claimApron(){
    if (S.aOwn) return;
    var p = sizeTrio('cape');
    S.aHeights = [p[0], p[1], p[2]]; S.aTied = S.tied; S.aOwn = true;
  }
  /* The millimetre a line actually comes out at on ONE garment, worked the
     same way drawArt works it. The picture can only ever show the garment
     being looked at, and the cart needs the answer for both. */
  /* The alphabet comes in as fnt, NOT f: three lines in, the local f below is
     the FIELD WIDTH, and a parameter called f that stops meaning the font
     half way down the function is exactly the sort of trap this file is
     written not to leave. */
  function drawnIn(view, text, h, fnt){
    if (!text) return null;
    var m = fitAt((fnt||S.fonts[0]).id, text, h.mm, fieldIn(view, h));
    return (m===null || isNaN(m)) ? null : m;
  }

  /* A phone turns a straight apostrophe into a curly one and a hyphen into a
     dash. No alphabet is cut with those, so "Mary's Hair" would fail canSet
     and stick the button. The Order Desk folds them before it looks a glyph
     up; the page now folds the same list, so what is measured, what is drawn
     and what reaches the order are the one string. */
  var TYPO={'‘':"'", '’':"'", '‛':"'", '“':'"',
            '”':'"', '–':'-', '—':'-', '‒':'-',
            ' ':' '};
  function fold(t){
    var o='';
    for (var i=0;i<t.length;i++){ var c=t[i]; o += (TYPO[c]!==undefined?TYPO[c]:c); }
    return o.replace(/\s+/g,' ').trim();
  }
  /* The line NUMBERS that carry text, in order: [0,2] when line one and line
     three are filled and line two is empty. Every lookup downstream - the
     alphabet, the cone, the size row, the order property - finds its line by
     this number, so a blank line in the middle cannot shift the line below it
     onto somebody else's choices. */
  function liveIdx(){
    var o=[];
    for (var i=0;i<3;i++){ if (fold(S.names[i])) o.push(i); }
    return o;
  }
  function lines(){
    return liveIdx().map(function(i){
      var t = fold(S.names[i]), f = fontOf(i);
      /* An alphabet cut as capitals throughout has no lowercase to stitch, so
         the page shows capitals before anybody pays rather than after. Asked
         per line now, because line two can be set in College while line one
         is not. */
      return (f && f.allCaps) ? t.toUpperCase() : t;
    });
  }
  function ready(){ return lines().length>0; }

  function drawGarment(){
    /* 1 Oct 2026 - Mack: "when selecting a color the color option glitch for a second". Every tap
       threw the cape photo away and loaded it again, so the picture blinked. Same photo, same place:
       it now stays put and only the lettering on it is redrawn. */
    var g=$('cb-garment'), G=GEO[S.view], key=[G.img,G.x,G.y,G.w,G.h].join('|');
    if (g._tk===key && g.firstChild) return;
    while(g.firstChild) g.removeChild(g.firstChild);
    var im=el('image',{x:G.x,y:G.y,width:G.w,height:G.h,preserveAspectRatio:'none'}); im.setAttribute('href',G.img); g.appendChild(im);
    g._tk=key;
  }
  /* Returns the millimetre height actually drawn (it steps down when a line is
     wider than the hoop field), so the order carries what the customer saw. */
  /* drawnReal says the millimetre figure above came from the ALPHABET, not
     from the stand-in web font the page paints with while the outlines are
     still downloading. It matters because the two disagree badly: Samantha's
     stand-in is Alex Brush, about 1.7x wider, so the page shrank the letters
     to make THAT fit and wrote 17 mm onto an order whose real answer was 28.
     The customer saw a handle filling the cape either way; only the number
     was wrong, and the workshop builds from the number.
     GFAIL marks an alphabet whose file will never arrive, so a fetch that
     fails cannot leave Add to cart disabled for good. */
  var drawnMm = null, drawnMms = [], drawnReal = false;

  /* THE RULE UNDER THE LETTERING. Mack, 10 Sep 2026: "below the cape can you
     put the size in inches like the mockup makes, with the line so they can
     see how big it is."

     Same drawing as the proof that comes back for sign-off - a dashed span
     with a tick at each end, the millimetres, then the inches - so the
     customer meets the measurement here and recognises it there. Inches
     because that is the unit a stylist in Texas holds a cape in; the
     millimetres stay because that is the unit the machine is set in.

     Drawn in white at low opacity: the cape is black, and a rule that reads
     as strongly as the name would compete with it. */
  function drawRule(g, wMm, bottomY, cx){
    if (!wMm || wMm < 8) return;
    var half = wMm/2, gap = 17, ry = bottomY + gap, tick = 3.4;
    var line = el('path', {d:'M'+(cx-half)+' '+ry+' L'+(cx+half)+' '+ry,
                           stroke:'#fff', 'stroke-opacity':.42, 'stroke-width':.9,
                           'stroke-dasharray':'4 4', fill:'none'});
    g.appendChild(line);
    [cx-half, cx+half].forEach(function(x){
      g.appendChild(el('path', {d:'M'+x+' '+(ry-tick)+' L'+x+' '+(ry+tick),
                                stroke:'#fff', 'stroke-opacity':.42,
                                'stroke-width':.9, fill:'none'}));
    });
    var mmT = el('text', {x:cx, y:ry+15, 'text-anchor':'middle',
                          'font-family':'Inter, sans-serif', 'font-size':12,
                          'letter-spacing':'.16em', fill:'#fff', 'fill-opacity':.66});
    mmT.textContent = Math.round(wMm)+' MM';
    g.appendChild(mmT);
    var inT = el('text', {x:cx, y:ry+28, 'text-anchor':'middle',
                          'font-family':'Lora, Georgia, serif', 'font-size':10.5,
                          'font-style':'italic', fill:'#fff', 'fill-opacity':.5});
    inT.textContent = '≈ '+(wMm/25.4).toFixed(1)+' inches';
    g.appendChild(inT);
  }
  /* What the order carries for a line: the size asked for, and the size it
     actually came out at when the width of the garment had the last word. */
  /* The width the size button bought, in the workshop's own words - the
     Order Desk takes --size STD / L / XL and these are those three fields. */
  /* WILL THIS LINE GO THAT TALL? Measured off the real glyphs, the same
     arithmetic the drawing uses, so the answer on the button and the picture
     beside it can never disagree. While the alphabet is still loading every
     size is offered - a button greyed out by a fetch that has not landed yet
     is worse than one that turns out to be optimistic. */
  function reachAt(text, h, fn){
    var f = fieldFor(h), id = (fn||S.fonts[0]).id;
    var need = widthAt(id, text, h.mm);
    if (need===null || isNaN(need)) return {known:false, drawn:h.mm, need:0, field:f};
    /* the same fit the drawing applies, so the button and the picture
       cannot disagree about what this size actually produces */
    var drawn = fitAt(id, text, h.mm, f);
    if (drawn===null || isNaN(drawn)) return {known:false, drawn:h.mm, need:0, field:f};
    return {known:true, drawn:drawn, need:Math.round(need), field:f};
  }
  /* A size is worth offering only if it beats the one below it. On a long name
     the width cap decides the height, so Tallest and Grand can both come out at
     the same millimetre - and a button that changes nothing is the thing Mack
     complained about in the first place. Those are the ones that get dimmed,
     not every size that happens to be clamped. */
  function reachRow(text, fn){
    var out=[], prev=0;
    HEIGHTS.forEach(function(h,k){
      var r = reachAt(text,h,fn);
      r.ok = !r.known || k===0 || r.drawn > prev + 0.5;
      prev = r.drawn;
      out.push(r);
    });
    return out;
  }

  /* i is the POSITION among the filled lines, because that is what the order
     numbers - Line 1, Line 2 - actually mean to the workshop. The size and
     the alphabet are then looked up by the line's own number, which is what
     the customer typed into. */
  function widthProp(i, view){
    var h = sizeTrio(view)[liveIdx()[i]];
    var f = fieldIn(view, h), w = SIZE_WORD[fieldIdx(h)] || '';
    return (w ? w+' · ' : '') + f + ' mm';
  }
  function heightProp(i, view){
    var n = liveIdx()[i], h = sizeTrio(view)[n];
    var dm = drawnIn(view, lines()[i], h, fontOf(n));
    return h.label+' ('+h.mm+' mm)'+(dm&&dm<h.mm?' — drawn at '+dm+' mm to fit':'');
  }
  function drawArt(){
    var g=$('cb-art'); while(g.firstChild) g.removeChild(g.firstChild);
    var G=GEO[S.view], cx=260, cy=G.chest;
    var ix=liveIdx(), ls=lines();
    if (!ls.length) {
      var p=el('text',{x:cx,y:cy+4,'text-anchor':'middle','font-family':'Inter, sans-serif','font-size':11,'letter-spacing':'.16em',fill:'rgba(255,255,255,.5)'});
      p.textContent = 'YOUR NAME'; g.appendChild(p); drawnMm=null; drawnReal=false; drawnMms=[]; return;
    }
    /* THE REAL ALPHABETS FIRST - one per line now. loadGlyphs repaints when a
       file lands, so the stand-in below is only ever what shows for the first
       moment, or for good if a fetch fails, which is the behaviour this page
       had before. Three lines can be three different alphabets and each has
       its own file to go and get. */
    var fs = ix.map(function(n){ return fontOf(n); });
    fs.forEach(function(f){ if (!glyphs(f.id)) loadGlyphs(f.id, function(){ paint(); }); });

    /* EACH LINE IS FITTED ON ITS OWN. It used to take the widest line, work
       out one shrink factor from it and apply that to every line - so a long
       first line dragged a short second line down with it, and a line already
       at the full width answered every size button with the same millimetre. */
    var trio = sizeTrio(S.view);
    var want = ix.map(function(n){ return trio[n].mm; });
    var caps = ix.map(function(n){ return fieldFor(trio[n]); });
    var ds   = [];
    var mms  = [];
    /* Every line has to be drawable from its OWN alphabet before any of them
       is drawn from one, because a page that mixed real outlines with the
       stand-in would quote a width measured two different ways. Each line is
       fitted from the file for the height it lands on (26 Oct). */
    var allReal = true;
    for (var q=0;q<ls.length;q++){
      if (!glyphs(fs[q].id)) { allReal=false; break; }
      var mq = fitAt(fs[q].id, ls[q], want[q], caps[q]);
      if (mq===null || isNaN(mq)) { allReal=false; break; }
      mms[q]=mq; ds[q]=glyphsAt(fs[q].id, mq);
      if (!ds[q] || !canSet(ds[q], ls[q])) { allReal=false; break; }
    }
    if (allReal) {
      drawnMms=mms.slice(); drawnMm=mms[0]; drawnReal=true;
      var totalG=0; mms.forEach(function(m){ totalG+=m; }); totalG+=(ls.length-1)*LINE_GAP_MM;
      var yG=cy-totalG/2, any=0, wideG=0;
      ls.forEach(function(t,i){
        var d=ds[i];
        any += drawGlyphLine(g,d,t,cx,yG+mms[i],mms[i],threadOf(ix[i]).hex);
        wideG = Math.max(wideG, glyphWidth(d,t)*((mms[i]/(d.srcMm||25))/10));
        yG+=mms[i]+LINE_GAP_MM;
      });
      if (any) { drawRule(g, wideG, cy+totalG/2, cx); return; }
      while(g.firstChild) g.removeChild(g.firstChild);
      drawnMms=[];
    }

    /* Stand-in, while the alphabets are still on their way. */
    mms=[]; var wsn=[];
    ls.forEach(function(t,i){
      var f=fs[i], m=want[i], cap=caps[i];
      var probe=el('text',{x:-9999,y:-9999,'font-family':f.web,'font-size':m*f.k});
      g.appendChild(probe); probe.textContent=t;
      var w=0; try{ w=probe.getComputedTextLength(); }catch(e){}
      g.removeChild(probe);
      var m0=m;
      if (w>cap) m=Math.max(12, Math.floor(m*cap/w));
      mms[i]=m; wsn[i]= m0 ? w*m/m0 : w;
    });
    drawnMms=mms.slice(); drawnMm=mms[0]; drawnReal=false;
    var total=0; mms.forEach(function(m){ total+=m; }); total+=(ls.length-1)*LINE_GAP_MM;
    var y=cy-total/2;
    ls.forEach(function(t,i){
      var m=mms[i], f=fs[i];
      var e=el('text',{x:cx,y:(y+m).toFixed(1),'text-anchor':'middle','font-family':f.web,'font-size':(m*f.k).toFixed(2),fill:threadOf(ix[i]).hex,stroke:'rgba(0,0,0,.35)','stroke-width':Math.max(.5,m*.02),'paint-order':'stroke','stroke-linejoin':'round'});
      e.textContent=t; g.appendChild(e); y+=m+LINE_GAP_MM;
    });
    var wideS=0; wsn.forEach(function(v){ wideS=Math.max(wideS, v||0); });
    drawRule(g, wideS, cy+total/2, cx);
  }

  function money(c){ return '$'+(c/100).toFixed(c%100?2:0); }
  function firstVar(p){ if(!p) return null; for (var i=0;i<p.variants.length;i++) if (p.variants[i].ok) return p.variants[i]; return null; }

  /* Swap a chip's stand-in text for the alphabet itself. */
  function chipPaint(lab,f,word){
    var d=glyphs(f.id); if(!d||!canSet(d,word)) return;
    var b=lab.querySelector('b'); if(!b) return;
    var mm=25, sU=(mm/(d.srcMm||25))/10, w=glyphWidth(d,word)*sU;
    var H=26, pad=2, sc=H/(mm*1.5), vw=Math.max(24,(w*sc)+pad*2);
    var svg=document.createElementNS(NS,'svg');
    svg.setAttribute('viewBox','0 0 '+vw.toFixed(1)+' '+H);
    svg.setAttribute('height',H); svg.setAttribute('width',vw.toFixed(1));
    svg.style.display='block';
    var g=el('g',{transform:'scale('+sc.toFixed(4)+')'});
    svg.appendChild(g);
    drawGlyphLine(g,d,word,(vw/2)/sc,(H*0.80)/sc,mm,'currentColor');
    b.textContent=''; b.appendChild(svg);
  }
  function chipReal(lab,f,word){
    if (glyphs(f.id)) { chipPaint(lab,f,word); return; }
    var go=function(){ loadGlyphs(f.id,function(){ chipPaint(lab,f,word); }); };
    if (!window.IntersectionObserver) { go(); return; }
    var io=new IntersectionObserver(function(en){
      en.forEach(function(e){ if(e.isIntersecting){ io.disconnect(); go(); } });
    },{root:null,rootMargin:'200px'});
    io.observe(lab);
  }
  /* SIX AT A TIME. Thirty chips and eight group headings ran a long way down
     a desktop screen and turned Step 2 into most of the page. The strip now
     shows a window of six around whatever is chosen - enough to compare
     neighbours at a glance - and the arrows and the list above it reach the
     other twenty-four. The group headings moved into the dropdown, which is
     where a heading is worth its height. */
  var FONT_WINDOW=6;
  function renderFonts(){
    var box=$('cb-fonts'); box.innerHTML='';
    var ix=liveIdx(); if (ix.length && ix.indexOf(S.fline)<0) S.fline=ix[0];
    var cur=fontOf(S.fline);
    var n=FONTS.length, at=0;
    FONTS.forEach(function(f,i){ if(f===cur) at=i; });
    var start=Math.max(0, Math.min(at-Math.floor(FONT_WINDOW/2), n-FONT_WINDOW));
    FONTS.slice(start, start+FONT_WINDOW).forEach(function(f){
      var lab=document.createElement('label'); lab.className='cb-font'+(f===cur?' on':''); lab.title=f.name+' — '+f.lab;
      var word = 'Abc';
      lab.innerHTML='<input type="radio" name="font"><b style="font-family:'+f.web.replace(/"/g,"'")+'">'+word+'</b><small>'+f.name+'</small>';
      lab.addEventListener('click',function(e){ e.preventDefault(); setFont(S.fline,f); renderFonts(); paint(); });
      box.appendChild(lab);
      /* The chip draws its own alphabet too, once that file is here. Loaded
         only when the chip is scrolled to, because thirty alphabets is about
         five megabytes and nobody looks at all of them. */
      chipReal(lab, f, word);
    });
    $('cb-fontname').textContent = cur.name+' · '+cur.lab+(liveIdx().length>1?' · '+LINE_WORD[S.fline].toLowerCase():'');
    renderFontSelect();
    renderLinePicks();
  }
  /* The same alphabets as the strip, grouped the same way, for anyone who
     would rather read a list than scroll one - and it is the whole thirty in
     one place on a desktop. */
  function renderFontSelect(){
    var sel=$('cb-fsel'); if(!sel) return;
    sel.innerHTML='';
    var group=null, holder=null;
    FONTS.forEach(function(f){
      if (f.lab!==group){ group=f.lab; holder=document.createElement('optgroup'); holder.label=f.lab||'Lettering'; sel.appendChild(holder); }
      var o=document.createElement('option'); o.value=f.id; o.textContent=f.name;
      if (f===fontOf(S.fline)) o.selected=true;
      (holder||sel).appendChild(o);
    });
  }
  function stepFont(dir){
    var cur=fontOf(S.fline), at=0; FONTS.forEach(function(f,i){ if(f===cur) at=i; });
    var n=FONTS.length;
    setFont(S.fline, FONTS[((at+dir)%n+n)%n]);
    renderFonts(); paint();
  }
  /* WHICH LINE AM I CHOOSING FOR. A row of line buttons above the alphabet
     strip and above the cones, and only while there is more than one line to
     choose between - a row of one button is a row that only asks a question.
     Built here rather than in sections/tod-solo.liquid because that file is
     47 KB of designer and stitch preview and is not worth retyping whole to
     gain two rows of buttons. */
  function linePickRow(id, host, before, cur, pick){
    var ix=liveIdx(), row=$(id);
    if (ix.length<2){ if(row&&row.parentNode) row.parentNode.removeChild(row); return; }
    if (!row){
      row=document.createElement('div'); row.id=id; row.className='cb-pills cb-lpick';
      host.insertBefore(row, before);
    }
    /* 1 Oct 2026 - Mack: "on step 3 of the cape when selecting line 1 and 2 it glitches". The row was torn down and
       built again on every repaint, and each tap ran twice (a tap on a label also clicks the radio inside it), so the
       swatches and the thread photo were drawn twice per tap. Now the same buttons stay and only the highlight moves;
       a tap runs once. */
    row._pick=pick;
    var key=ix.join(',');
    if (row.getAttribute('data-k')===key && row.children.length===ix.length){
      [].forEach.call(row.children, function(l,i){ l.className=(ix[i]===cur?'on':''); });
      return;
    }
    row.setAttribute('data-k', key);
    row.innerHTML='';
    ix.forEach(function(n){
      var lab=document.createElement('label');
      lab.className=(n===cur?'on':'');
      lab.innerHTML='<input type="radio">'+LINE_WORD[n];
      lab.addEventListener('click',function(e){ e.preventDefault(); row._pick(n); });
      row.appendChild(lab);
    });
  }
  function renderLinePicks(){
    var fb=$('cb-fonts'), tb=$('cb-threads');
    if (fb && fb.parentNode){
      var nav=fb.previousElementSibling && fb.previousElementSibling.className.indexOf('cb-fnav')>-1 ? fb.previousElementSibling : fb;
      linePickRow('cb-fline', fb.parentNode, nav, S.fline, function(n){ S.fline=n; renderFonts(); });
    }
    if (tb && tb.parentNode){
      linePickRow('cb-tline', tb.parentNode, tb, S.tline, function(n){ S.tline=n; renderThreads(); });
    }
  }
  /* One size row per line. Line two only appears when there IS a line two,
     and it follows line one until the customer touches it - after that it is
     its own. The caption underneath says the millimetre actually stitched,
     because a line at the full width of the cape cannot grow and the buttons
     look broken without it. Mack, 10 Sep: "long fonts dont get moved at all,
     and it does both the lines at once". */
  /* What to say under a row. Set by a tap on a size this line cannot reach,
     and cleared by the next repaint - so the reason stays up while the
     customer reads it, and goes as soon as they change anything. */
  var sizeMsg = ['','',''];
  var LINE_WORD = ['Line one','Line two','Line three'];

  /* The section's markup carries two size rows and two name boxes. The third
     of each is cloned from the second the first time it is asked for, rather
     than added to sections/tod-solo.liquid - 47 KB of designer, thirty
     alphabets and the stitch preview, and the only way to write it is to
     retype it whole. Cloning keeps every class and every style in step with
     the row above it for free. */
  function ensureRow3(){
    if ($('cb-hrow3')) return true;
    var r2=$('cb-hrow2'); if (!r2) return false;
    var r3=r2.cloneNode(true);
    r3.id='cb-hrow3';
    var lab=r3.querySelector('.cb-hlab'); if (lab) lab.textContent='Line three';
    var pills=r3.querySelector('.cb-pills'); if (pills) pills.id='cb-height3';
    var fit=r3.querySelector('.cb-hfit'); if (fit){ fit.id='cb-fit3'; fit.textContent=''; }
    r2.parentNode.insertBefore(r3, r2.nextSibling);
    return true;
  }

  function renderHeights(){
    function row(boxId,fitId,n){
      var box=$(boxId); if(!box) return; box.innerHTML='';
      var cur = sizeTrio(S.view)[n];
      var f = fontOf(n);
      var text = fold(S.names[n]);
      if (text && f && f.allCaps) text = text.toUpperCase();
      var reach = text ? reachRow(text, f) : null;
      HEIGHTS.forEach(function(h,k){
        var r = reach ? reach[k] : {ok:true};
        var lab=document.createElement('label');
        lab.className = (h===cur?'on':'') + (r.ok?'':' cb-cant');
        lab.innerHTML='<input type="radio">'+h.label+' · '+h.mm+' mm';
        lab.addEventListener('click',function(e){
          e.preventDefault();
          if (!r.ok){
            /* Not silently ignored and not silently shrunk - the page says
               which line is in the way, because that is the only version of
               this the customer can act on. */
            sizeMsg[n] = LINE_WORD[n]+' is too long. Shorten it to get larger letters.';
            renderHeights();
            return;
          }
          sizeMsg[n]='';
          if (S.view==='apron') {
            claimApron();
            if (n===0) { S.aHeights[0]=h; if (S.aTied){ S.aHeights[1]=h; S.aHeights[2]=h; } }
            else {
              /* Untying has to carry the sizes the other lines were already
                 showing across first, or a line nobody touched jumps to
                 whatever was last left in its slot. */
              if (S.aTied){ S.aHeights[1]=S.aHeights[0]; S.aHeights[2]=S.aHeights[0]; S.aTied=false; }
              S.aHeights[n]=h;
            }
          } else {
            if (n===0) { S.heights[0]=h; if (S.tied){ S.heights[1]=h; S.heights[2]=h; } }
            else {
              if (S.tied){ S.heights[1]=S.heights[0]; S.heights[2]=S.heights[0]; S.tied=false; }
              S.heights[n]=h;
            }
          }
          paint();
        });
        box.appendChild(lab);
      });
      var fit=$(fitId); if(!fit) return;
      if (sizeMsg[n]) { fit.textContent = sizeMsg[n]; return; }
      /* drawnMms is indexed by POSITION among the filled lines, because that
         is the order drawArt walked them in. */
      var pos = liveIdx().indexOf(n);
      var dm = pos>-1 ? drawnMms[pos] : null;
      /* Same plain words as the dimmed-size message, for the same reason:
         the millimetres were the workshop's arithmetic, not something the
         customer can do anything with. */
      fit.textContent = (dm && dm<cur.mm)
        ? LINE_WORD[n]+' fills the width. Shorten it to get larger letters.'
        : '';
    }
    ensureRow3();
    /* A size row per line that has something on it, hidden otherwise - and
       line one's row is hidden too now, because with three lines it is no
       longer certain that line one is one of them. */
    var pairs=[['cb-height','cb-fit1'],['cb-height2','cb-fit2'],['cb-height3','cb-fit3']];
    for (var n=0;n<3;n++){
      var b=$(pairs[n][0]);
      var host=b && b.closest ? b.closest('.cb-hrow') : null;
      var on=!!fold(S.names[n]);
      if (host) host.hidden=!on;
      if (on) row(pairs[n][0], pairs[n][1], n);
    }
    /* Said in the one place the sizes are set, and only while the apron is the
       thing on screen, because that is the only moment the sentence is true. */
    var as=$('cb-async');
    if (as) {
      if (!S.apron || S.view!=='apron') { as.hidden=true; as.innerHTML=''; }
      else {
        as.hidden=false;
        as.innerHTML = S.aOwn
          ? 'The apron has sizes of its own. <button type="button" id="cb-amatch">Match the cape again</button>'
          : 'The apron is following the cape. Tap a size here to give it its own.';
        var mb=$('cb-amatch');
        if (mb) mb.addEventListener('click', function(){ S.aOwn=false; paint(); });
      }
    }
  }
  function renderThreads(){
    var box=$('cb-threads');
    var ix=liveIdx(); if (ix.length && ix.indexOf(S.tline)<0) S.tline=ix[0];
    var cur=threadOf(S.tline), list=popFirst(THREADS);
    /* 1 Oct 2026 - the cones stay where they are and only the ring moves (they used to be torn
       down and built again on every tap, which is the flicker Mack saw). */
    function same(t){ return t===cur || (!!cur && !!t && String(t.spool)===String(cur.spool) && t.name===cur.name); }
    /* matched by the cone each button carries, not by position - another script reorders them */
    if (box._tl===list.length && box.children.length===list.length && [].every.call(box.children,function(l){ return !!l._t; })){
      [].forEach.call(box.children, function(l){ l.classList.toggle('on', same(l._t)); });
    } else {
    box.innerHTML=''; box._tl=list.length;
    list.forEach(function(t){
      var lab=document.createElement('label'); lab.className=((t===cur||(!!cur&&String(t.spool)===String(cur.spool)&&t.name===cur.name))?'on':'')+(isPopular(t)?' pop':''); lab.style.background=t.hex; lab.title=t.name+' · '+t.spool+(isPopular(t)?' · popular':'');
      lab.innerHTML='<input type="radio" name="thread">'; lab._t=t;
      lab.addEventListener('click',function(e){ e.preventDefault(); setThread(S.tline,t); renderThreads(); paint(); });
      box.appendChild(lab);
    });
    }
    $('cb-thrname').textContent=cur.name+' · Madeira '+cur.spool+(liveIdx().length>1?' · '+LINE_WORD[S.tline].toLowerCase():'');
    var tp=$('cb-tphoto');
    if(!tp){ tp=document.createElement('div'); tp.id='cb-tphoto'; box.parentNode.insertBefore(tp, box.nextSibling); }
    /* only when the thread shown changes - redrawing it on every tap made the photo blink and shut "Can't find your color?" */
    var tk=String(cur.spool)+'|'+cur.name;
    if (tp.getAttribute('data-k')!==tk){ if(!tpSwap(tp,cur)) tp.innerHTML=threadPhoto(cur); tp.setAttribute('data-k',tk); }
    renderLinePicks();
  }
  function showMode(){ renderFonts(); }

  function paint(){
    var cv=firstVar(D.cape), av=S.apron?firstVar(D.apron):null;
    sizeMsg=['','','']; drawGarment(); drawArt(); renderHeights();
    /* The line buttons above the alphabets and the cones appear and disappear
       with the lines themselves, so they are settled on every repaint rather
       than only when somebody touches a font. Typing into line two is what
       brings them out, and nothing about typing goes near renderFonts. */
    var ixp=liveIdx();
    if (ixp.length){
      if (ixp.indexOf(S.fline)<0){ S.fline=ixp[0]; renderFonts(); }
      if (ixp.indexOf(S.tline)<0){ S.tline=ixp[0]; renderThreads(); }
    }
    renderLinePicks();
    var box=$('cb-lines'); box.innerHTML='';
    var sub=(cv?cv.price*S.qty:0)+(av?av.price*S.apronQty:0);
    function row(a,b,cls){ var d=document.createElement('div'); if(cls)d.className=cls; d.innerHTML='<span>'+a+'</span><b>'+b+'</b>'; box.appendChild(d); }
    var many = !!(DESIGNS && DESIGNS.length>1), avAny=firstVar(D.apron);
    /* capes listed in tab order - your cape first, then each friend's */
    function rowCur(){
      row(S.qty+' × '+(many ? designWho(CUR)+' — '+(lines()[0] ? '“'+tpEsc(lines()[0])+'”' : 'no name yet') : D.cape.title), cv?money(cv.price*S.qty):'—');
      if (av) row(S.apronQty+' × Matching apron'+(many?' ('+designWho(CUR).toLowerCase()+')':''), money(av.price*S.apronQty));
    }
    if (!many) rowCur();
    if (many) DESIGNS.forEach(function(o,i){
      if (i===CUR){ rowCur(); return; }
      if (!o) return;
      var nm=(o.names.filter(function(x){ return fold(x); })[0]||'').trim();
      row(o.qty+' × '+designWho(i)+' — '+(nm ? '“'+tpEsc(nm)+'”' : 'no name yet'), cv?money(cv.price*o.qty):'—');
      sub += cv ? cv.price*o.qty : 0;
      if (o.apron && avAny){ row(o.apronQty+' × Matching apron ('+designWho(i).toLowerCase()+')', money(avAny.price*o.apronQty)); sub += avAny.price*o.apronQty; }
    });
    var ship = sub>=D.freeShipOver ? 0 : D.flatShip, gap=D.freeShipOver-sub;
    row('Shipping', ship===0?'Free':money(ship), 'ship');
    if (ship>0) { var d=document.createElement('div'); d.innerHTML='<span><em>'+money(gap)+' more and it ships free'+(D.apron&&!S.apron?' — add the apron or a second cape':'')+'</em></span>'; box.appendChild(d); }
    /* 8 Sep: S.qty went up and the total went up with it, but this line did
       not exist, so the figure in the box sat on 1 for ever and the page
       looked broken to anybody trying to buy two. */
    $('cb-q').textContent=S.qty;
    var aqBox=$('cb-aqty');
    if (aqBox){ aqBox.hidden=!S.apron; $('cb-aq').textContent=S.apronQty; }
    $('cb-total').textContent=money(sub);
    $('cb-ship-note').textContent = ship===0 ? 'ships free' : '+ '+money(ship)+' shipping';
    var ix0=liveIdx();
    var askedMm = sizeTrio(S.view)[ix0.length?ix0[0]:0].mm;
    var sizeNote = (drawnMm && drawnReal) ? (drawnMm<askedMm ? ' · fits at '+drawnMm+' mm' : ' · '+askedMm+' mm') : '';
    /* One cone named while every line is wearing it; "mixed threads" the
       moment they are not, because naming one of three would be a caption
       that contradicts the picture right above it. */
    var thrName = !ix0.length ? S.threads[0].name : (oneThread() ? threadOf(ix0[0]).name : 'mixed threads');
    $('cb-capname').textContent = (S.view==='apron'?'Matching apron':'Cutting cape')+' · centred · '+thrName+sizeNote;
    $('cb-tabs').hidden=!S.apron;
    $('cb-bar-total').textContent=money(sub);
    var fName = !ix0.length ? S.fonts[0].name : (oneFont() ? fontOf(ix0[0]).name : 'mixed lettering');
    $('cb-bar-sub').textContent = ready() ? lines().join(' / ')+' · '+fName+(av?' + '+S.apronQty+' apron'+(S.apronQty>1?'s':''):'')+(ship?' + '+money(ship)+' shipping':' · ships free') : 'Type the name to start';
    /* Nothing is bought until the real alphabets have drawn it. An alphabet
       whose file cannot be fetched at all is let through - but with three
       lines that has to be true of EVERY line in the design, or a cape goes
       out measured half from the outlines and half from a stand-in. */
    var stitching = drawnReal || (ix0.length>0 && ix0.every(function(n){ return !!GFAIL[fontOf(n).id]; }));
    $('cb-bar-btn').textContent = !ready() ? 'Start' : (stitching ? 'Add to cart' : 'One moment…');
    $('cb-zoom').textContent = S.view==='apron' ? 'Tap to see the whole apron' : 'Tap to see the whole cape';
    /* Nothing may be bought until the real alphabet has drawn it, because
       until then the only measurement on the page is the stand-in's and that
       is what reaches the workshop. An alphabet whose file cannot be fetched
       at all is let through - the order simply carries no millimetre figure,
       and the Order Desk measures it there instead. */
    var ok=ready()&&!!cv&&(!S.apron||!!av)&&stitching&&othersReady();
    $('cb-add').disabled=!ok;
    var lb=$('cb-add').querySelector('.lbl');
    if (lb) lb.textContent = (ready()&&!stitching) ? 'Drawing your lettering…' : 'Add to cart';
    var m=$('cb-msg'); m.className='cb-msg';
    m.textContent = !ready() ? 'Type the name to add this cape.'
      : !othersReady() ? 'Give every friend\u2019s cape a name - or tap × to remove it.'
      : !stitching ? 'Drawing your name in the real stitches — one moment.'
      : 'Ready — '+money(sub)+(ship?' + '+money(ship)+' shipping':'')+'.';
    /* Whoever else is drawing this design - the stepped 1-2-3 flow and its
       summary card live in assets/tod-solo-steps.js and repaint from here. */
    for (var hi=0; hi<HOOKS.length; hi++){ try{ HOOKS[hi](); }catch(e){} }
  }

  /* wiring */
  $('cb-fprev').addEventListener('click', function(){ stepFont(-1); });
  $('cb-fnext').addEventListener('click', function(){ stepFont(1); });
  $('cb-fsel').addEventListener('change', function(e){
    for (var i=0;i<FONTS.length;i++) if (FONTS[i].id===e.target.value) { setFont(S.fline, FONTS[i]); break; }
    renderFonts(); paint();
  });
  var NAME_ID=['cb-name','cb-name2','cb-name3'], CNT_ID=['cb-c1','cb-c2','cb-c3'];
  function bindName(n){
    var box=$(NAME_ID[n]); if(!box || box.getAttribute('data-tod-bound')) return;
    box.setAttribute('data-tod-bound','1');
    box.addEventListener('input', function(e){
      S.names[n]=e.target.value;
      var c=$(CNT_ID[n]); if(c) c.textContent=S.names[n].length;
      paint();
    });
  }
  /* The third name box, cloned off the second - same reasoning as the third
     size row, see ensureRow3. */
  function ensureName3(){
    if ($('cb-name3')) { bindName(2); return; }
    var b=$('cb-name2'); if(!b) return;
    var c=b.cloneNode(false);
    c.id='cb-name3'; c.value=''; c.setAttribute('placeholder','Line three (optional) — Wylie, Texas');
    c.removeAttribute('data-tod-bound');
    var cnt=document.createElement('div'); cnt.className='cb-cnt';
    cnt.innerHTML='<span id="cb-c3">0</span>/20';
    var tail=b.nextElementSibling;
    b.parentNode.insertBefore(c, tail ? tail.nextSibling : null);
    c.parentNode.insertBefore(cnt, c.nextSibling);
    bindName(2);
  }
  bindName(0); bindName(1);
  /* + ADD ANOTHER LINE, the way the salon-set pages do it. The third box does
     not exist until it is asked for, so nobody meets an empty field they did
     not want. */
  (function(){
    var b=$('cb-name2'); if(!b||!b.parentNode) return;
    var add=document.createElement('button');
    add.type='button'; add.className='cb-addline'; add.id='cb-addline';
    add.textContent='+ Add another line';
    b.parentNode.appendChild(add);
    add.addEventListener('click', function(){
      ensureName3(); S.rows=3;
      if (add.parentNode) add.parentNode.removeChild(add);
      var n3=$('cb-name3'); if(n3) n3.focus();
      paint();
    });
    var st=document.createElement('style');
    st.textContent='.cb-addline{display:block;width:100%;margin-top:4px;padding:13px;cursor:pointer;'
      +'background:none;border:1.5px dashed var(--line);color:var(--mauve-dk);'
      +'font:600 10.5px/1 var(--sans);letter-spacing:.14em;text-transform:uppercase;transition:.2s var(--ease)}'
      +'.cb-addline:hover{border-color:var(--navy);color:var(--navy)}'
      +'.cb-lpick{margin-bottom:12px}'
      +'.cb-lpick label{padding:9px 12px;font-size:10px}';
    document.head.appendChild(st);
  })();
  /* Taking the apron off the order takes its separate sizes with it. Left
     armed, a customer who tried the apron, gave it its own height, then
     changed their mind and re-ticked it later would ship a cape and an apron
     at different sizes from a choice they had switched off - and with the
     millimetres now hidden at checkout there is nowhere they could see it. */
  var apCb=$('cb-apron'); if (apCb) apCb.addEventListener('change', function(e){ S.apron=e.target.checked; if(!S.apron){S.view='cape'; S.aOwn=false; setTab();} paint(); });
  function setTab(){ Array.prototype.forEach.call($('cb-tabs').querySelectorAll('button'),function(b){ b.classList.toggle('on', b.getAttribute('data-view')===S.view); }); }
  $('cb-tabs').addEventListener('click', function(e){ var b=e.target.closest('button'); if(!b)return; S.view=b.getAttribute('data-view'); setTab(); paint(); });
  /* full view: the whole garment, lettering where it will be stitched */
  function openFull(){
    var G=GEO[S.view], fs=$('cb-full-svg');
    fs.setAttribute('viewBox', G.x+' '+G.y+' '+G.w+' '+G.h);
    fs.innerHTML=$('cb-svg').innerHTML;
    $('cb-full-name').textContent=(S.view==='apron'?'Your apron':'Your cape')+(ready()?' · '+lines().join(' / '):'');
    $('cb-full').hidden=false; document.body.style.overflow='hidden'; window.dispatchEvent(new Event('resize'));
  }
  function closeFull(){ $('cb-full').hidden=true; document.body.style.overflow=''; window.dispatchEvent(new Event('resize')); }
  /* out of the theme's header stacking context (the sticky header is z-index 8) */
  document.body.appendChild($('cb-full'));
  $('cb-svg').addEventListener('click', openFull);
  $('cb-zoom').addEventListener('click', openFull);
  $('cb-full').addEventListener('click', closeFull);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeFull(); });
  /* phone bottom bar: visible only while the designer is on screen and the
     real Add to cart button is not */
  (function(){
    var bar=$('cb-bar'), btn=$('cb-add'), sec=document.getElementById('design'), tick=false;
    function upd(){
      var vh=window.innerHeight, s=sec.getBoundingClientRect(), b=btn.getBoundingClientRect();
      var secSeen = s.top < vh*0.6 && s.bottom > vh*0.5;
      var btnSeen = b.top < vh && b.bottom > 0;
      var on = window.innerWidth<=1000 && secSeen && !btnSeen && $('cb-full').hidden;
      bar.classList.toggle('show', on); bar.setAttribute('aria-hidden', on?'false':'true'); tick=false;
    }
    function ask(){ if(!tick){ tick=true; setTimeout(upd, 60); } }
    window.addEventListener('scroll', ask, {passive:true});
    window.addEventListener('resize', ask);
    ask();
    $('cb-bar-btn').addEventListener('click', function(){
      if (ready()) { btn.scrollIntoView({block:'center'}); btn.click(); return; }
      var inp = $('cb-name');
      inp.scrollIntoView({block:'center'}); inp.focus();
    });
  })();
  $('cb-minus').addEventListener('click', function(){ S.qty=Math.max(1,S.qty-1); paint(); });
  $('cb-plus').addEventListener('click', function(){ S.qty=Math.min(50,S.qty+1); paint(); });
  /* guarded, because the whole apron block sits behind a Liquid if - the shop
     can sell out of aprons and then these buttons do not exist */
  var amn=$('cb-aminus'), apl=$('cb-aplus');
  if (amn) amn.addEventListener('click', function(){ S.apronQty=Math.max(1,S.apronQty-1); paint(); });
  if (apl) apl.addEventListener('click', function(){ S.apronQty=Math.min(50,S.apronQty+1); paint(); });

  /* ---- ADD TO CART (multipart, so a file property could ride along) --- */
  function post(variantId, qty, props){
    var fd=new FormData(); fd.append('id', variantId); fd.append('quantity', qty);
    Object.keys(props).forEach(function(k){ fd.append('properties['+k+']', props[k]); });
    return fetch(D.addUrl + '.js', { method:'POST', body: fd, headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description||j.message||'Could not add to cart'); return j; }); });
  }
  /* 1 Oct 2026 - what ONE cape (the design in S right now) puts in the cart. Pulled out of the
     button so the friends' capes below go through exactly the same lines. */
  function orderOf(){
    var cv=firstVar(D.cape), av=S.apron?firstVar(D.apron):null;
    var props={}, ls=lines(), ix=liveIdx();
    ls.forEach(function(t,i){ props['Line '+(i+1)]=t; });
    /* 19 SEP 2026. ONE Font PROPERTY WHILE EVERY LINE WEARS THE SAME
       ALPHABET - byte for byte what this page has always sent, so an order
       that does not mix reaches the Order Desk looking exactly as it did
       yesterday and nothing downstream has to change for it.

       A design that DOES mix carries one property per line instead, and
       _Mixed with it. make_order.py should look for _Mixed first: if it is
       there, there is no single Font or Thread to read and the lines have to
       be built one at a time, with a colour stop between them. */
    if (oneFont()) props['Font']=fontOf(ix[0]).name;
    else ls.forEach(function(t,i){ props['Font line '+(i+1)]=fontOf(ix[i]).name; });
    /* 12 SEP 2026. THE MILLIMETRES ARE HIDDEN FROM THE CUSTOMER.
       Shopify treats a property whose name begins with an underscore as
       private: it is kept on the order, shown in the admin and returned by
       the API - which is where shop_orders.py and the paste box read it -
       but the cart and the checkout do not print it.

       Mack, 12 Sep: "on the checkout screen is it possible to hide the
       machine text code and just show the apron and cape". A cape carried
       ten lines of properties into checkout and six of them were workshop
       arithmetic - the field width in millimetres, the height it had been
       clamped to, the placement, the matching note. What is left is what
       the customer actually chose and can still proof-read at the last
       moment: the two lines of lettering, the alphabet and the cone.

       The set designer already did this with _TOD Spec; this is the same
       convention, applied to the page that had the longest list. */
    props['_Letter height']=heightProp(0,'cape');
    props['_Lettering width']=widthProp(0,'cape');
    for (var li=1; li<ls.length; li++){
      props['_Letter height line '+(li+1)]=heightProp(li,'cape');
      props['_Lettering width line '+(li+1)]=widthProp(li,'cape');
    }
    if (oneThread()) {
      var t0=threadOf(ix[0]);
      props['Thread']=t0.name+' · Madeira '+t0.spool;
    } else {
      ls.forEach(function(t,i){
        var tc=threadOf(ix[i]);
        props['Thread line '+(i+1)]=tc.name+' · Madeira '+tc.spool;
      });
    }
    if (!oneFont() || !oneThread()) {
      props['_Mixed']='This design changes '
        + (!oneFont() && !oneThread() ? 'alphabet and colour'
           : (!oneFont() ? 'alphabet' : 'colour'))
        + ' between lines — build it line by line';
    }
    props['_Placement']='Centred';
    var notes=$('cb-notes').value.trim(); if (notes) props['Notes']=notes;
    /* 12 SEP 2026, THE FIX. These four were worked out inside the .then(),
       which does not run until the cape has finished being added - and the
       size buttons stay live the whole time the button says "Adding...". A
       customer who taps a size in that second or two put one height on the
       cape and a different one on the apron, in the same order, having seen
       neither. Everything the apron carries is now settled here, before
       anything is sent. */
    var apQty = S.apronQty, ap = null;
    if (av) {
      ap = {}; for (var k in props) ap[k] = props[k];
      ap['_Matches']='the cape in this order';
      /* The apron's own four figures. Even when it is still following the cape
         the WIDTH differs, because the field it is stitched into is narrower -
         the old copy of the cape's properties told the workshop 180 mm for a
         piece whose Standard is 150. */
      ap['_Letter height']=heightProp(0,'apron');
      ap['_Lettering width']=widthProp(0,'apron');
      for (var aj=1; aj<ls.length; aj++){
        ap['_Letter height line '+(aj+1)]=heightProp(aj,'apron');
        ap['_Lettering width line '+(aj+1)]=widthProp(aj,'apron');
      }
      if (S.aOwn) ap['_Apron sizing']='Sized on its own, not matched to the cape';
    }
    return {cv:cv, av:av, props:props, ap:ap, qty:S.qty, apQty:apQty};
  }
  $('cb-add').addEventListener('click', function(){
    var cv=firstVar(D.cape); if (!ready()||!cv||!othersReady()) return;
    var btn=$('cb-add'), m=$('cb-msg'); btn.disabled=true; m.className='cb-msg'; m.textContent='Adding to your cart…';
    var orders=allOrders(), chain=Promise.resolve(), value=0;
    orders.forEach(function(o){
      value += o.cv.price*o.qty + (o.av ? o.av.price*o.apQty : 0);
      chain=chain.then(function(){ return post(o.cv.id, o.qty, o.props); });
      if (o.av) chain=chain.then(function(){ return post(o.av.id, o.apQty, o.ap); });
    });
    chain.then(function(){
        try { if (typeof window.fbq==='function') window.fbq('track','AddToCart',{content_name:'Solo cape',value:value/100,currency:'USD'}); } catch(e){}
        m.textContent='Added. Taking you to your cart…'; window.location.href=D.cartUrl;
      })
      .catch(function(err){ btn.disabled=false; m.className='cb-msg err'; m.textContent=(err&&err.message?err.message:'Something went wrong')+' — try again, or text us at (469) 368-5805.'; });
  });

  /* 12 SEP 2026. This file is loaded with defer, so between the box
     appearing and this line running there is a CDN round trip - and on a slow
     phone that is long enough to type a salon name into. Nothing replays an
     input event that happened before the listener existed, so the name sat in
     the box while the page believed it was empty: the preview said YOUR NAME
     and Add to cart stayed disabled. Worse if they reached line two first,
     because then line two was the only line the order carried. Whatever is
     already in the two boxes is read here, once, before the first paint. */
  (function(){
    NAME_ID.forEach(function(id,n){
      var e=$(id);
      if (e && e.value){
        S.names[n]=e.value;
        var c=$(CNT_ID[n]); if(c) c.textContent=S.names[n].length;
      }
    });
  })();

  /* ---- THE HANDLE THE STEPPED UI HOLDS ON TO ------------------------------
     19 SEP 2026. assets/tod-solo-steps.js builds the numbered 1-2-3 flow the
     salon-set pages use - the steps bar, the line cards, the summary of what
     has been chosen - and needs to read and set what is chosen here.

     Exposing it is what keeps THAT file small and stops this one being
     retyped again. Every future change to the LOOK of the designer happens
     out there; this file goes on owning the alphabets, the fitting, the
     stitch preview and the cart, which are the parts that must not be
     touched casually. Anything added here is a promise to that file, so
     nothing in this list gets renamed without changing it too. */
  /* ---- CAPES FOR FRIENDS ------------------------------------------------------
     1 OCT 2026. Mack: "on the single cape designer can you add a button above the add matching apron
     on step 1 that says design a cape for a friend and they can add up to 3 and make them all
     different" - up to 3 capes in all, and each can have its own apron.

     The cape on screen is S, exactly as before. The others wait in DESIGNS as copies of S, and a tab
     row above the steps swaps between them. Nothing about drawing, measuring or the order lines
     changed: Add to cart puts each cape back into S in turn and asks orderOf() for its lines, so every
     cape reaches the Order Desk looking like its own single-cape order (plus a private _Design note,
     "Cape 2 of 3 · for a friend"). Notes go on the first cape only. */
  var MAXD=3, DESIGNS=[null], CUR=0;
  var DKEYS=['names','fonts','threads','heights','aHeights','fontSet','threadSet'],
      DVALS=['rows','tied','apron','qty','apronQty','aTied','aOwn','fline','tline'];
  function snap(){ var o={}; DKEYS.forEach(function(k){ o[k]=S[k].slice(); }); DVALS.forEach(function(k){ o[k]=S[k]; }); return o; }
  function setS(o){ DKEYS.forEach(function(k){ S[k]=o[k].slice(); }); DVALS.forEach(function(k){ S[k]=o[k]; }); }
  function freshDesign(){
    return { names:['','',''], fonts:[FONTS[0],FONTS[0],FONTS[0]], threads:[GOLD,GOLD,GOLD],
      heights:[HEIGHTS[0],HEIGHTS[0],HEIGHTS[0]], aHeights:[HEIGHTS[0],HEIGHTS[0],HEIGHTS[0]],
      fontSet:[true,false,false], threadSet:[true,false,false], rows:Math.min(S.rows,2), tied:true,
      apron:false, qty:1, apronQty:1, aTied:true, aOwn:false, fline:0, tline:0 };
  }
  function designWho(i){ return i===0 ? 'Your cape' : 'Friend '+i+'\u2019s cape'; }
  function hasName(o){ return o.names.some(function(x){ return !!fold(x); }); }
  function othersReady(){
    if (!DESIGNS || DESIGNS.length<2) return true;
    return DESIGNS.every(function(o,i){ return i===CUR || (o && hasName(o)); });
  }
  /* one design onto the page: the boxes, the apron tick, the alphabets, the cones, the picture */
  function put(o){
    setS(o); S.view='cape';
    if (o.names[2] && !$('cb-name3')) { var more=$('cb-addline'); if (more) more.click(); else ensureName3(); }
    setS(o); S.view='cape';
    var ap=$('cb-apron'); if (ap) ap.checked=!!S.apron;
    try { setTab(); } catch(e){}
    NAME_ID.forEach(function(id,n){
      var e=$(id); if(!e) return;
      e.value=S.names[n]||'';
      try { e.dispatchEvent(new Event('input',{bubbles:true})); } catch(x){}
    });
    renderFonts(); renderHeights(); renderThreads(); paint();
  }
  function goDesign(i){
    if (i===CUR || !DESIGNS[i]) return;
    DESIGNS[CUR]=snap(); CUR=i; put(DESIGNS[i]); renderFriends(true);
  }
  function addFriend(){
    if (DESIGNS.length>=MAXD) return;
    DESIGNS[CUR]=snap(); DESIGNS.push(freshDesign()); CUR=DESIGNS.length-1;
    put(DESIGNS[CUR]); renderFriends(true);
    var first=document.querySelector('.tsx-bar .tsx-step'); if (first && !first.classList.contains('on')) first.click();
    var n=$('cb-name'); if (n){ try{ n.focus({preventScroll:true}); }catch(e){ n.focus(); } var bar=$('cb-friends'); if (bar && bar.scrollIntoView) bar.scrollIntoView({block:'start',behavior:'smooth'}); }
  }
  function dropDesign(i){
    if (i<=0 || !DESIGNS[i]) return;
    DESIGNS[CUR]=snap();
    DESIGNS.splice(i,1);
    if (i===CUR){ CUR=0; put(DESIGNS[0]); } else if (i<CUR) CUR--;
    renderFriends(true); paint();
  }
  /* every cape's order lines, then the one on screen goes back */
  function allOrders(){
    if (!DESIGNS || DESIGNS.length<2) return [orderOf()];
    DESIGNS[CUR]=snap();
    var out=[];
    DESIGNS.forEach(function(o,i){
      setS(o);
      var r=orderOf(), tag='Cape '+(i+1)+' of '+DESIGNS.length+(i>0?' \u00b7 for a friend':'');
      r.props['_Design']=tag; if (r.ap) r.ap['_Design']=tag;
      if (i>0){ delete r.props['Notes']; if (r.ap) delete r.ap['Notes']; }
      out.push(r);
    });
    setS(DESIGNS[CUR]);
    return out;
  }
  var FKEY='';
  function renderFriends(force){
    var form=$('cb-form'); if (!form || !DESIGNS) return;
    if (DESIGNS[CUR]===null) DESIGNS[CUR]=null;
    var labels=DESIGNS.map(function(o,i){
      var src = i===CUR ? S : o, nm=(src.names.filter(function(x){ return fold(x); })[0]||'').trim();
      return designWho(i)+(nm?' \u00b7 '+nm:'');
    });
    var key=labels.join('|')+'#'+CUR;
    var bar=$('cb-friends');
    if (!bar){ bar=document.createElement('div'); bar.id='cb-friends'; bar.className='cbf-bar'; bar.setAttribute('role','tablist'); form.insertBefore(bar, form.firstChild); }
    if (force || key!==FKEY){
      FKEY=key; bar.innerHTML=''; bar.hidden = DESIGNS.length<2;
      labels.forEach(function(t,i){
        var b=document.createElement('button'); b.type='button'; b.className='cbf-tab'+(i===CUR?' on':''); b.setAttribute('role','tab');
        b.innerHTML='<span>'+tpEsc(t)+'</span>'+(i>0?'<i role="button" aria-label="Remove this cape" data-x="1">\u00d7</i>':'');
        b.addEventListener('click', function(e){ e.preventDefault(); if (e.target && e.target.getAttribute && e.target.getAttribute('data-x')) dropDesign(i); else goDesign(i); });
        bar.appendChild(b);
      });
    }
    var add=$('cb-friend-add');
    if (!add){
      add=document.createElement('button'); add.type='button'; add.id='cb-friend-add'; add.className='cbf-add';
      add.addEventListener('click', function(e){ e.preventDefault(); addFriend(); });
    }
    var tick=document.querySelector('.tas-add'), anchor=tick || ($('cb-apron') && $('cb-apron').closest('.cb-step'));
    if (anchor && anchor.parentNode && add.nextSibling!==anchor) anchor.parentNode.insertBefore(add, anchor);
    var cv=firstVar(D.cape), left=MAXD-DESIGNS.length;
    add.hidden = left<=0;
    var txt='<b aria-hidden="true">+</b><span>Design a cape for a friend<small>'+(DESIGNS.length<2 ? 'Up to '+MAXD+' capes \u00b7 each its own name, style and color' : left+' more '+(left===1?'cape':'capes')+' can be added')+(cv?' \u00b7 '+money(cv.price)+' each':'')+'</small></span>';
    if (add.innerHTML!==txt) add.innerHTML=txt;
  }
  (function(){
    var st=document.createElement('style');
    st.textContent='.cbf-add{display:flex;align-items:center;gap:12px;width:100%;margin:14px 0 12px;padding:14px 16px;border:1.5px dashed #d9a441;border-radius:14px;'
      +'background:#fffaf0;color:#0b0d12;cursor:pointer;text-align:left;font:700 14px/1.25 var(--sans,Inter,Arial,sans-serif);-webkit-tap-highlight-color:transparent}'
      +'.cbf-add:hover{border-style:solid;background:#fff5e0}.cbf-add[hidden]{display:none}'
      +'.cbf-add b{flex:none;width:32px;height:32px;border-radius:50%;display:grid;place-items:center;background:linear-gradient(135deg,#d9a441,#d4668a);color:#fff;font:700 20px/1 Arial}'
      +'.cbf-add small{display:block;margin-top:3px;font:500 12px/1.35 var(--sans,Inter,Arial,sans-serif);color:#6b6158}'
      +'.cbf-bar{display:flex;gap:8px;overflow-x:auto;margin:0 0 14px;padding:2px 2px 4px;scrollbar-width:none}.cbf-bar::-webkit-scrollbar{display:none}.cbf-bar[hidden]{display:none}'
      +'.cbf-tab{flex:none;display:inline-flex;align-items:center;gap:8px;min-height:42px;padding:0 14px;border-radius:999px;border:1px solid #d8cfc0;background:#fff;color:#0b0d12;'
      +'font:700 12.5px/1 var(--sans,Inter,Arial,sans-serif);cursor:pointer;white-space:nowrap;max-width:240px}'
      +'.cbf-tab span{overflow:hidden;text-overflow:ellipsis}.cbf-tab.on{background:#0b0d12;border-color:#0b0d12;color:#fff}'
      +'.cbf-tab i{font-style:normal;font-size:16px;line-height:1;opacity:.55;padding:2px 0 2px 4px}.cbf-tab i:hover{opacity:1}';
    document.head.appendChild(st);
  })();
  /* 1 Oct 2026. Mack: "under Your design - when making 2 different capes at step 3 show the other cape and apron too".
     The step-3 summary (assets/tod-solo-steps.js) lists the cape on screen; with friends' capes this adds a small
     picture and the lines of every other cape, and its apron, under it - tap one to edit it. The cape on screen gets
     a label so the list reads "Your cape / Friend 1's cape". Built only when something changed. */
  function linesOf(o){
    var out=[]; (o.names||[]).forEach(function(x,n){ var t=String(x||'').trim(); if(!t||!fold(t)) return;
      out.push({t:t, f:(o.fontSet[n]?o.fonts[n]:o.fonts[0])||FONTS[0], th:(o.threadSet[n]?o.threads[n]:o.threads[0])||GOLD, h:o.heights[n]||HEIGHTS[0]}); });
    return out;
  }
  function thumb(img, ls, W, H, cy, span){
    if (!img) return '';
    var t=ls[0], txt='';
    if (t){ var fs=Math.min(H*0.12, (W*span)/(Math.max(3,t.t.length)*0.5*(t.f.k?1/t.f.k*1.2:1)));
      txt='<text x="'+(W/2)+'" y="'+cy+'" text-anchor="middle" font-family="'+tpEsc(t.f.web||'cursive')+'" font-size="'+fs.toFixed(1)+'" fill="'+tpEsc(t.th.hex||'#DAB654')+'" stroke="rgba(0,0,0,.35)" stroke-width=".25" paint-order="stroke">'+tpEsc(t.t)+'</text>'; }
    return '<svg class="cbf-th" viewBox="0 0 '+W+' '+H+'" aria-hidden="true"><image href="'+tpEsc(img)+'" width="'+W+'" height="'+H+'" preserveAspectRatio="xMidYMid meet"/>'+txt+'</svg>';
  }
  var SUMKEY='';
  function renderSum(){
    var card=document.querySelector('.tsx-sum'), body=card && card.querySelector('.tsx-sum-body'); if (!card || !body) return;
    var many = DESIGNS && DESIGNS.length>1;
    var cur=$('cbf-sum-cur'), box=$('cbf-sum');
    if (!cur){ cur=document.createElement('p'); cur.id='cbf-sum-cur'; cur.className='cbf-sum-cur'; card.insertBefore(cur, body); }
    if (!box){ box=document.createElement('div'); box.id='cbf-sum'; box.className='cbf-sum'; card.appendChild(box); }
    if (box.previousElementSibling!==body && box!==card.lastElementChild) card.appendChild(box);
    var curHtml = many ? '<span class="cbf-cur-t"><b>'+tpEsc(designWho(CUR))+'</b> &middot; on screen</span>'+qtyCtl(CUR, S) : '';
    var html='';
    if (many) DESIGNS.forEach(function(o,i){
      if (i===CUR || !o) return;
      var ls=linesOf(o);
      html+='<div class="cbf-sd" role="button" tabindex="0" data-d="'+i+'">'+
        '<span class="cbf-pics">'+thumb(D.capeImg, ls, 46, 60, 15.5, .62)+(o.apron?thumb(D.apronImg, ls, 26, 60, 17, .72):'')+'</span>'+
        '<span class="cbf-sd-t"><b>'+tpEsc(designWho(i))+(o.apron?' + matching apron':'')+'</b>'+
        (ls.length ? ls.map(function(l){ return '<span class="cbf-ln"><i style="background:'+tpEsc(l.th.hex||'#DAB654')+'"></i><em>'+tpEsc(l.t)+'</em> '+tpEsc(l.f.name)+' &middot; '+tpEsc(l.th.name)+' &middot; '+tpEsc(l.h.label)+' '+l.h.mm+' mm</span>'; }).join('')
          : '<span class="cbf-ln cbf-none">No name yet &mdash; tap to finish this cape</span>')+
        qtyCtl(i, o)+'</span><span class="cbf-edit">Edit</span></div>';
    });
    var key=curHtml+'#'+html;
    if (key===SUMKEY) return; SUMKEY=key;
    cur.innerHTML=curHtml; cur.hidden=!many;
    box.innerHTML=html; box.hidden=!html;
    if (!card._cbf){ card._cbf=1;
      card.addEventListener('click', function(e){
        var q=e.target.closest && e.target.closest('[data-q]');
        if (q && card.contains(q)){ e.preventDefault(); e.stopPropagation(); bump(+q.getAttribute('data-i'), q.getAttribute('data-k'), +q.getAttribute('data-q')); return; }
        var c=e.target.closest && e.target.closest('.cbf-sd'); if (c && card.contains(c)){ e.preventDefault(); goDesign(+c.getAttribute('data-d')); }
      });
      card.addEventListener('keydown', function(e){ var c=e.target; if ((e.key==='Enter'||e.key===' ') && c.classList && c.classList.contains('cbf-sd')){ e.preventDefault(); goDesign(+c.getAttribute('data-d')); } });
    }
  }
  /* 1 Oct 2026. Mack: "on step 3 is it possible to add more of that one cape so lets say friend 2 wants 3 and friend one
     just wants 1 and friend 3 want 2". Every cape (and its apron) keeps its own count - S.qty / S.apronQty for the one on
     screen, DESIGNS[i].qty / .apronQty for the others - and each card in "Your design" has its own - 1 + for it. */
  var QMAX=20;
  function qtyCtl(i, o){
    function one(k, n, word){ return '<span class="cbf-q"><button type="button" data-i="'+i+'" data-k="'+k+'" data-q="-1" aria-label="One fewer '+word+'"'+(n<=1?' disabled':'')+'>&minus;</button><b>'+n+'</b><button type="button" data-i="'+i+'" data-k="'+k+'" data-q="1" aria-label="One more '+word+'"'+(n>=QMAX?' disabled':'')+'>+</button><small>'+word+(n>1?'s':'')+'</small></span>'; }
    return '<span class="cbf-qs">'+one('c', o.qty||1, 'cape')+(o.apron?one('a', o.apronQty||1, 'apron'):'')+'</span>';
  }
  function bump(i, k, d){
    var o = i===CUR ? S : DESIGNS[i]; if (!o) return;
    var f = k==='a' ? 'apronQty' : 'qty';
    o[f] = Math.max(1, Math.min(QMAX, (o[f]||1)+d));
    paint();
  }
  function qtyLabels(){
    var many = DESIGNS && DESIGNS.length>1, who = CUR===0 ? 'Your' : 'Friend '+CUR+'\u2019s';
    var l=document.querySelectorAll('.cb-buy .cb-qty-lab');
    if (l[0]) { var t = many ? who+' capes' : 'Capes'; if (l[0].textContent!==t) l[0].textContent=t; }
    if (l[1]) { var t2 = many ? who+' aprons' : 'Aprons'; if (l[1].textContent!==t2) l[1].textContent=t2; }
  }
  (function(){
    var st=document.createElement('style');
    st.textContent='.cbf-sum-cur{margin:-4px 0 8px;font:600 12px/1.3 var(--sans,Inter,Arial,sans-serif);color:#6b6158}.cbf-sum-cur b{color:#0b0d12}.cbf-sum-cur[hidden],.cbf-sum[hidden]{display:none}'
      +'.cbf-sum{display:grid;gap:8px;margin-top:12px;padding-top:12px;border-top:1px dashed #d8cfc0}'
      +'.cbf-sd{all:unset;box-sizing:border-box;cursor:pointer;display:flex;align-items:center;gap:12px;width:100%;padding:10px 12px;border-radius:14px;background:#fffaf0;border:1px solid #eadfcd;-webkit-tap-highlight-color:transparent}'
      +'.cbf-sd:hover{border-color:#d9a441}.cbf-sd:focus-visible{outline:3px solid #d9a441;outline-offset:2px}'
      +'.cbf-pics{flex:none;display:flex;align-items:flex-end;gap:2px;padding:4px;border-radius:10px;background:#ece6d8}'
      +'.cbf-th{display:block;width:46px;height:60px}.cbf-th + .cbf-th{width:26px}'
      +'.cbf-sd-t{flex:1;min-width:0;display:grid;gap:4px}.cbf-sd-t > b{font:700 13px/1.25 var(--sans,Inter,Arial,sans-serif);color:#0b0d12}'
      +'.cbf-ln{display:flex;align-items:center;gap:6px;flex-wrap:wrap;font:500 12px/1.35 var(--sans,Inter,Arial,sans-serif);color:#6b6158}'
      +'.cbf-ln i{flex:none;width:10px;height:10px;border-radius:50%;box-shadow:0 0 0 1px rgba(0,0,0,.15)}.cbf-ln em{font-style:normal;font-weight:700;color:#0b0d12}'
      +'.cbf-none{color:#b23f67;font-weight:600}'
      +'.cbf-sum-cur{display:flex;align-items:center;justify-content:space-between;gap:8px;flex-wrap:wrap}'
      +'.cbf-qs{display:flex;flex-wrap:wrap;gap:6px;margin-top:2px}'
      +'.cbf-q{display:inline-flex;align-items:center;gap:2px;padding:2px;border-radius:999px;background:#fff;border:1px solid #e3d8c6}'
      +'.cbf-q button{all:unset;box-sizing:border-box;width:30px;height:30px;border-radius:50%;display:grid;place-items:center;cursor:pointer;font:700 16px/1 Arial;color:#0b0d12;-webkit-tap-highlight-color:transparent}'
      +'.cbf-q button:hover{background:#f3ead8}.cbf-q button[disabled]{opacity:.3;cursor:default}.cbf-q button:focus-visible{outline:2px solid #d9a441}'
      +'.cbf-q b{min-width:18px;text-align:center;font:800 14px/1 var(--sans,Inter,Arial,sans-serif);color:#0b0d12}'
      +'.cbf-q small{padding:0 8px 0 4px;font:600 11px/1 var(--sans,Inter,Arial,sans-serif);color:#6b6158}'
      +'.cbf-edit{flex:none;font:700 11px/1 var(--sans,Inter,Arial,sans-serif);letter-spacing:.08em;text-transform:uppercase;color:#b8862a}';
    document.head.appendChild(st);
  })();
  HOOKS.push(function(){ renderFriends(false); });
  HOOKS.push(function(){ try { renderSum(); qtyLabels(); } catch(e){} });

  window.TOD_SOLO_API = {
    S:S, FONTS:FONTS, THREADS:THREADS, HEIGHTS:HEIGHTS, LINE_WORD:LINE_WORD,
    liveIdx:liveIdx, lines:lines, ready:ready, fold:fold,
    fontOf:fontOf, threadOf:threadOf, setFont:setFont, setThread:setThread,
    oneFont:oneFont, oneThread:oneThread,
    sizeTrio:sizeTrio, reachRow:reachRow, fieldFor:fieldFor,
    ensureName3:ensureName3, ensureRow3:ensureRow3, bindName:bindName,
    paint:function(){ paint(); },
    renderFonts:function(){ renderFonts(); },
    renderThreads:function(){ renderThreads(); },
    renderHeights:function(){ renderHeights(); },
    orders:function(){ return allOrders(); },
    on:function(fn){ if (typeof fn==='function') HOOKS.push(fn); }
  };

  showMode(); renderHeights(); renderThreads(); paint(); loadManifest();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint);
})();
